import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/store/auth-store'
import { DashboardLayout } from '@/components/layout/DashboardLayout'

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ location }) => {
    const { token, user } = useAuthStore.getState()
    if (!token) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }

    // Admins on a tenant that hasn't finished onboarding get pushed through
    // the wizard. We never gate non-admins on this — agents/supervisors are
    // invited by the admin and shouldn't see the setup screen. A missing flag
    // is treated as completed (legacy sessions, hand-rolled JWTs, etc).
    const role = user?.role ?? 'agent'
    const isAdmin = role === 'admin' || role === 'super_admin'
    if (isAdmin && user?.onboarding_completed === false) {
      throw redirect({ to: '/onboarding' })
    }
  },
  component: DashboardLayout,
})
